export default __webpack_public_path__ + "static/media/helen_malcolm.37ef215c.jpg";